import React from 'react';
import { observer } from 'mobx-react';
import { RouteComponentProps, Route, Switch } from 'react-router';
import { Button } from '../components/common/Button';
import routes from 'routes';
import { UwTaskListDesign, TreuebonusBerichtDesign } from './design/TreuebonusDesigns';
import { AspTimelineDesign, AspPotentialListeDesign, AspAgtDashboardDesign, AspJpgIntegrationDesign } from './design/asp/AspDesigns';

interface IDesignExample {
	key: string;
	group: string;
	label: string;
	description: string;
	component: React.ComponentType<RouteComponentProps>;
}

const DESIGN_EXAMPLES: IDesignExample[] = [
	{
		key: 'uw-task-list',
		group: 'Treuebonus',
		label: 'UW Task List',
		description: 'View for Underwriter',
		component: UwTaskListDesign,
	},
	{
		key: 'uw-treuebonus-bericht',
		group: 'Treuebonus',
		label: 'Treuebonus Bericht',
		description: 'View for VBL',
		component: TreuebonusBerichtDesign,
	},
	{
		key: 'asp-timeline',
		group: 'ASP',
		label: 'ASP Übersicht / Kalender',
		description: 'Horizontale Jahres-Timeline aller Kampagnen mit Vorbereitungsphase',
		component: AspTimelineDesign,
	},
	{
		key: 'asp-potentialliste',
		group: 'ASP',
		label: 'Potentialliste',
		description: 'Kundenpotenzial je Agentur und Kampagne, Zeile öffnet Zuweisungs-Modal',
		component: AspPotentialListeDesign,
	},
	{
		key: 'asp-agt-dashboard',
		group: 'ASP',
		label: 'Agentur Dashboard mit ASP Widget',
		description: 'Mock Agentur-Dashboard mit Top-5-Potenzial-Widget',
		component: AspAgtDashboardDesign,
	},
	{
		key: 'asp-jpg',
		group: 'ASP',
		label: 'JPG Integration',
		description: 'JPG Dokument mit ASP-Fokusthemen und Potenzial',
		component: AspJpgIntegrationDesign,
	},
];

const DesignIndex = observer((props: RouteComponentProps) => {
	const navigate = (key: string) => {
		props.history.push(routes.DESIGN.getPath(key));
	};

	return (
		<div className="pad-1rem">
			<div className="page-header content">
				<h1>Designs</h1>
			</div>

			<table className="table">
				<thead>
					<tr>
						<th>Group</th>
						<th>Name</th>
						<th>Description</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{DESIGN_EXAMPLES.map((example) => (
						<tr key={example.key} onClick={() => navigate(example.key)}>
							<td>
								<strong>{example.group}</strong>
							</td>
							<td>
								<strong>{example.label}</strong>
							</td>
							<td>{example.description}</td>
							<td>
								<Button className="button is-primary" onClick={() => navigate(example.key)}>
									View
								</Button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
});

const DesignContainer = observer((props: RouteComponentProps<{ level1?: string }>) => {
	return (
		<Switch>
			{DESIGN_EXAMPLES.map((example) => (
				<Route key={example.key} path={routes.DESIGN.getPath(example.key)} render={(routeProps) => <example.component {...routeProps} />} />
			))}
			<Route exact path={routes.DESIGN.route} render={(routeProps) => <DesignIndex {...routeProps} />} />
		</Switch>
	);
});

export default DesignContainer;
